/**
 * ticketShape.js — map a Firestore ticketChecks record to the unified ticket
 * shape used across the dashboard (pure).
 */
import { tsToLocal } from './dateUtils';
import { normalizeTimeMap } from './prepUtils';
import { deriveSnapshotCount } from '../ticketTimingUtils';

export function fsRecordToTicket(r) {
  const createdAt = r.createdAtISO
    ? new Date(r.createdAtISO)
    : (r.completedAt ? tsToLocal(r.completedAt) : null);
  const items = (r.itemsSnapshot || []).map(it => ({
    name: it.name,
    qty: it.qty || 1,
    priceCents: it.priceCents || 0,
    variationName: it.variationName || null,
    note: it.note || null,
    modifiers: Array.isArray(it.modifiers) ? it.modifiers : [],
  }));
  const manDone = !!r.manuallyCompleted;
  const allChecked = items.length > 0 && (r.checkedItems || []).length >= items.length;
  const prepTimeMin = r.prepTimeMin ?? r.timeTakenMin ?? null;
  const prepCompletedAt = r.prepCompletedAt || (prepTimeMin != null ? r.completedAt || null : null);
  const prepSource = r.prepSource || (prepTimeMin != null ? 'completion' : null);
  let status;
  if (manDone || allChecked) status = 'completed';
  else if (r.assigned || (r.checkedItems || []).length > 0) status = 'inprogress';
  else status = 'open';
  return {
    id: r.id,
    squareState: 'COMPLETED',
    ticketName: r.ticketName || null,
    customerName: null,
    status,
    createdAt: createdAt ? createdAt.toISOString() : null,
    closedAt: r.completedAt ? tsToLocal(r.completedAt)?.toISOString() : null,
    timeTakenMin: r.timeTakenMin ?? null,
    prepCompletedAt,
    prepTimeMin,
    prepSource,
    total: r.total ?? null,
    items,
    checkedItems: r.checkedItems || [],
    chefDoneMs: normalizeTimeMap(r.chefDoneMs),
    itemCheckedMs: normalizeTimeMap(r.itemCheckedMs),
    itemFireTimes: r.itemFireTimes || null,
    snapshotCount: deriveSnapshotCount({
      itemsSnapshot: r.itemsSnapshot,
      manuallyCompleted: manDone,
      checkedItems: r.checkedItems,
    }),
    reopenedAt: r.reopenedAt ? (r.reopenedAt.toDate ? r.reopenedAt.toDate().toISOString() : new Date(r.reopenedAt).toISOString()) : null,
    manuallyCompleted: manDone,
    assigned: !!r.assigned,
    assignedItems: r.assignedItems || [],
    category: null,
    pendingReason: r.pendingReason || null,
    pendingReasonAt: r.pendingReasonAt || null,
  };
}
